/*
 * Created Date: 17-01-2024, 12:06:45 pm
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified:
 * Modified By:
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import BaseService from '@Core/axios/BaseService'

class Auth extends BaseService {
	BASE_URL = 'https://studio-api-07.eduquiz.io.vn'

	constructor(params) {
		super(params)
		this.setRequest()
	}

	// studioCsrf = () => {
	// 	const endpoint = '/sanctum/csrf-cookie'
	// 	return this.request.get(endpoint)
	// }

	csrf = () => {
		const endpoint = '/sanctum/csrf-cookie'
		return this.request.get(endpoint)
	}

	loginWithPassword = async data => {
		const endpoint = '/workspace/public/api/v1/auth/login'
		await this.csrf()
		return this.request.post(endpoint, data)
	}

	adminLoginAccountUser = async data => {
		const endpoint = '/auth/api/v1/login-by-admin'
		await this.csrf()
		return this.request.post(endpoint, data)
	}

	getUserInfo = () => {
		const endpoint = '/workspace/studio/api/v1/auth/me'
		return this.request.get(endpoint)
	}

	register = data => {
		const endpoint = '/workspace/public/api/v1/auth/register'
		return this.request.post(endpoint, data)
	}

	logout = () => {
		const endpoint = '/workspace/studio/api/v1/auth/logout'
		return this.request.post(endpoint)
	}

	// verifyEmail = data => {
	// 	const endpoint = API_AUTH.verifyEmail.endpoint
	// 	return this.request.post(endpoint, data)
	// }

	resendVerifyCode = () => {
		const endpoint = '/workspace/studio/api/v1/auth/resent-verify-code'
		return this.request.post(endpoint)
	}

	forgotPassword = data => {
		const endpoint = '/workspace/public/api/v1/auth/forgot-password'
		return this.request.post(endpoint, data)
	}

	resetPassword = data => {
		const endpoint = '/workspace/public/api/v1/auth/reset-password'
		return this.request.post(endpoint, data)
	}

	changePassword = data => {
		const endpoint = '/workspace/studio/api/v1/auth/change-password'
		return this.request.post(endpoint, data)
	}

	updateInfo = data => {
		const endpoint = '/workspace/studio/api/v1/auth/user-info'
		return this.request.post(endpoint, data)
	}

	loginBySocial = (provider, data, query = {}) => {
		const endpoint = `/auth/api/v1/login/${provider}`
		const params = { ...query }

		return this.request.post(endpoint, data, params)
	}

	// notification = params => {
	// 	const endpoint = API_AUTH.notification.endpoint
	// 	return this.request.get(endpoint, { params })
	// }

	// readNotification = () => {
	// 	const endpoint = '/auth/api/v1/read-notifications'
	// 	return this.request.get(endpoint)
	// }

	// getRewardPoint = params => {
	// 	const endpoint = '/auth/api/v1/user-point'
	// 	return this.request.get(endpoint, { params })
	// }

	// getAffiliateChanelStatus = chanel_alias => {
	// 	const endpoint = `/affiliate/api/chanel/v1/user/check-active-affiliate?chanel_alias=${chanel_alias}`
	// 	return this.request.get(endpoint)
	// }
	verifyEmail = data => {
		const endpoint = `workspace/studio/api/v1/auth/verify-email`
		return this.request.post(endpoint, data)
	}
}
const authService = new Auth()
export default authService
